// test1966
(1966 && 0);
